import initialStates from './initialState'
import { encyptedData } from '../views/Access'

const GlobalReducer = (state, { type, payload }) => {
  switch (type) {
    case "PROFILE":
      localStorage.setItem("USERDATA", encyptedData(payload))
      localStorage.setItem("USERTOKEN", encyptedData(payload.userToken))
      return {
        ...state,
        isAuthenticated: true,
        userType: payload.role,
        userId: payload._id,
        userName: payload.username,
        firstName: payload.firstName,
        lastName: payload.lastName,
        officialEmail: payload.email,
        createdBy: payload.createdBy,
        // memberTypes: payload.memberType,
      }
    case "MEMBER_TYPE":
      localStorage.setItem("memberType", payload.memberType);
    return {
        ...state,
        memberTypes: payload.memberType,
      }
    case "LOGOUT":
    localStorage.clear();
    return initialStates
    default:
      return state
  }
}
export default GlobalReducer
